import { ChangeDetectionStrategy, Component } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { INoRowsOverlayParams } from 'ag-grid-community';

@Component({
  selector: 'xvi-no-rows-overlay-text',
  templateUrl: './no-rows-text-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XVINoRowsTextOverlay implements INoRowsOverlayAngularComp {
  public params: INoRowsOverlayParams & { noRowsMessageFunc: () => string };

  public agInit(
    params: INoRowsOverlayParams & { noRowsMessageFunc: () => string },
  ): void {
    this.params = params;
  }
}
